var camelize = require("camelize");
import { LOG_OUT } from "../redux/slices/userSlice";
import { store } from "../redux/store";

const { dispatch } = store;
export function setupAxios(axios, store) {
  // if (location.origin.includes("sstit.ir")) {
  //   axios.defaults.baseURL = "https://backend.sstit.ir/";
  // } else {
  //   if (location.protocol !== "https:") {
  //     axios.defaults.baseURL = "http://51.89.107.194:9191/";
  //   } else {
  //     axios.defaults.baseURL = "https://51.89.107.194:444/";
  //   }
  // }
  // axios.defaults.baseURL = "https://kmbackend.sstit.ir";
  axios.defaults.baseURL = "https://inspectionbackend.rasadyar.com/";

  axios.interceptors.request.use(
    (config) => {
      const {
        userSlice: { userAuthToken },
      } = store.getState();
      if (userAuthToken) {
        config.headers["Authorization"] = `${userAuthToken}`;
        config.headers.Accept = "application/json";
      }
      return config;
    },
    (err) => Promise.reject(err)
  );
  axios.interceptors.response.use(function (response) {
    return camelize(response);
  });

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        console.log("Token has Expired");
        dispatch(LOG_OUT());
      }
      return error;
    }
  );
}
